// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__17fQx","list":"PatternAutocomplete_list__1pvx4"};